import { Injectable } from "@angular/core";
export interface ColorPalette
{
  baseColors: Array<string>;
  additionalColors: Array<string>;
}

@Injectable()
export class ColorPaletteService
{
  private baseColors: Array<string> = [
      '#cd5c5c', '#fa8072', '#dc143c', '#ff0000', '#ffc0cb', '#ff1493',
      '#ff7f50', '#ff6347', '#ff4500', '#ffa500', '#ffd700', '#ffff00',
      '#ffdab9', '#e6e6fa', '#ee82ee', '#ff00ff', '#9400d3', '#8b008b',
      '#4b0082', '#483d8b', '#00ff00', '#98fb98', '#00ff7f', '#008000',
      '#6b8e23', '#66cdaa', '#20b2aa', '#008080', '#00ffff', '#7fffd4',
      '#40e0d0', '#4682b4', '#87cefa', '#1e90ff', '#0000cd', '#ffdead',
      '#f4a460', '#bc8f8f', '#d2691e', '#a0522d', '#a52a2a', '#800000',
      '#ffffff', '#f0fff0', '#f0f8ff', '#fff0f5', '#dcdcdc', '#a9a9a9',
      '#708090', '#000000',
  ];

  private _colorPalette: ColorPalette = {
    baseColors: this.baseColors,
    additionalColors: [],
  };

  public reset(): void
  {
    this._colorPalette.additionalColors = [];
  }

  public get colorPalette(): ColorPalette
  {
    return this._colorPalette;
  }

  public set colorPalette(palette: ColorPalette)
  {
    this._colorPalette = palette;
  }

  public addColors(_colors: Array<string> | string): void
  {
    const colors = typeof _colors === 'string' ? [ _colors ] : _colors;

    const addColor = (color) => {
      const colorIndex = this._colorPalette.additionalColors.indexOf(color);
      if (colorIndex === -1) {
        this._colorPalette.additionalColors.push(color);
      }
    };

    for (const color of colors) {
      addColor(color);
    }
  }
}
